import {
    COMMISSIONS_GET_STOCK_BEGIN,
    COMMISSIONS_GET_STOCK_SUCCESS,
    COMMISSIONS_GET_STOCK_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMISSIONS_GET_STOCK_BEGIN:
        return {
          ...state,
          policies: {
            ...state.policies,
            stockLoading: true,
            stockFailure: false,
            stockData:[]
          }
        }
      case COMMISSIONS_GET_STOCK_SUCCESS:
        return {
          ...state,
          policies: {
            ...state.policies,
            stockData: action.data.stockData,
            brands: action.data.brands,
            stockLoading: false,
            stockFailure: false
          }
        }
  
      case COMMISSIONS_GET_STOCK_FAILURE:
        return {
          ...state,
          policies: {
            ...state.policies,
            stockLoading: false,
            stockFailure: true
          }
        }
      default:
        return state
    }
  }
  